import { render, staticRenderFns } from "./payModal.vue?vue&type=template&id=70978dea&scoped=true&"
import script from "./payModal.vue?vue&type=script&lang=js&"
export * from "./payModal.vue?vue&type=script&lang=js&"
import style0 from "./payModal.vue?vue&type=style&index=0&id=70978dea&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70978dea",
  null
  
)

export default component.exports